import React, { CSSProperties } from 'react';

interface CoolingProps {
  detailListStyle: CSSProperties,
  cooling: Array<string> | undefined,
}

const Cooling = ({detailListStyle, cooling}: CoolingProps) => {
	return (
		<React.Fragment>
			<p className="text-uppercase cc-font-weight--bold mb-1">
				<i className="fal fa-snowflake me-2" />
        Cooling
			</p>
			<ul style={detailListStyle}>
				{Array.isArray(cooling) && cooling.length > 0 ? (
					cooling?.map((item: string, i: number) => {
						return <li key={i}>{item}</li>;
					})
				) : (
					<li>No cooling</li>
				)}
			</ul>
		</React.Fragment>
	);
};

export default Cooling;